<template>
  <footer class="ew-footer" :class="{ 'ew-footer--visible': isAtBottom }">
    <p class="ew-footer-copy mb-0 text-center text-truncate">
      © {{ currentYear }} SackTech Logistics. Todos los derechos reservados.
    </p>
  </footer>
</template>

<script>
export default {
  name: "AppFooter",
  data() {
    return {
      isAtBottom: false,
    };
  },
  computed: {
    currentYear() {
      return new Date().getFullYear();
    }
  },
  mounted() {
    window.addEventListener('scroll', this.checkScrollPosition, { passive: true });
    window.addEventListener('resize', this.checkScrollPosition);
    this.$nextTick(this.checkScrollPosition);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.checkScrollPosition);
    window.removeEventListener('resize', this.checkScrollPosition);
  },
  methods: {
    checkScrollPosition() {
      const scrollBottom = window.innerHeight + window.scrollY;
      const pageHeight = document.documentElement.scrollHeight;
      this.isAtBottom = scrollBottom >= pageHeight - 10;
    }
  }
};
</script>

<style scoped>
.ew-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1020;
  background: #ffffff;
  color: #2c2e78;
  font-family: 'Segoe UI', sans-serif;
  border-top: 1px solid rgba(44, 46, 120, 0.1);
  padding: 0.4rem 1rem;
  opacity: 0;
  transform: translateY(100%);
  pointer-events: none;
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.ew-footer--visible {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

.ew-footer-copy {
  font-size: 0.8rem;
  font-weight: 300;
  opacity: 0.8;
}
</style>



// WEBPACK FOOTER //
// src/components/AppFooter.vue